// URL contract for explicit semantic destinations in the Funder workspace.
// Content selection (e.g. `excerpt=<videoId>`) and viewport intent are kept
// separate: the selected entity can remain in the URL while `landing=video`
// tells the page which registered section should be placed in view.

export const FUNDER_WORKSPACE_LANDING_PARAM = "landing";
export const FUNDER_WORKSPACE_VIDEO_TARGET = "video";

export type FunderWorkspaceLandingTarget = typeof FUNDER_WORKSPACE_VIDEO_TARGET;

export function setFunderWorkspaceLandingTarget(
  params: URLSearchParams,
  target: FunderWorkspaceLandingTarget,
): void {
  params.set(FUNDER_WORKSPACE_LANDING_PARAM, target);
}

export function parseFunderWorkspaceLandingTarget(
  search: string,
): FunderWorkspaceLandingTarget | null {
  const value = new URLSearchParams(search).get(FUNDER_WORKSPACE_LANDING_PARAM);
  return value === FUNDER_WORKSPACE_VIDEO_TARGET ? value : null;
}
